import { Contact } from "@/models/base";
import { i18n } from "@/setup/i18n-setup";
import { getContactServiceByGroupId } from "../services/contact-services";

export class SaleEditStateContactExtraInfoEdit {
	private onCloseHandlers:((contact:Contact)=>void)[] = [];

	private modalOpened:boolean = false;

	public text:string = "";
	private contact:Contact = new Contact();

	public isSaving:boolean = false;

	public getContactGroupName():string {
		let contactGroupId = this.contact.GroupID;
		return i18n.t(`common.contact-group.${contactGroupId}`).toString();
	}

	public isOpen():boolean {
		return this.modalOpened;
	}

	public async open(contact:Contact):Promise<Contact> {
		if (this.modalOpened) return new Promise((resolve)=>{
			this.onCloseHandlers.push(resolve);
		});
		this.text = contact.Info;
		this.contact = contact;
		this.modalOpened = true;
		return new Promise((resolve)=>{
			this.onCloseHandlers.push(resolve);
		});
	}

	public async save(){
		if (this.isSaving) return;
		try{
			this.isSaving = true;
			let contactService = getContactServiceByGroupId(this.contact.GroupID);
			let contact = await contactService.getContact(this.contact.ID);
			contact.Info = this.text;
			contact = await contactService.putContact(contact);
			for (let handler of this.onCloseHandlers){
				handler(contact);
			}
			this.modalOpened = false;
			this.onCloseHandlers = [];
		}catch(err){

		}finally{
			this.isSaving = false;
		}
	}

	public async cancel(){
		for (let handler of this.onCloseHandlers){
			handler(this.contact);
		}
		this.modalOpened = false;
		this.onCloseHandlers = [];
	}

}